export const DEVICE_TYPE = {
  NORMAL_MOBILE: 'NORMAL_MOBILE',     // 竖屏手机
  FOLDABLE_OPEN: 'FOLDABLE_OPEN',     // 折叠屏展开 / 宽屏手机
  TABLET: 'TABLET',                   // 平板 / 桌面小窗口
  DESKTOP: 'DESKTOP'                  // 大屏桌面 / 较宽的电脑窗口
};

export const getDeviceType = () => {
  const ua = navigator.userAgent;
  let screenWidth = 0;
  let screenHeight = 0;
  if (window.screen) {
    screenWidth = window.screen.width;
    screenHeight = window.screen.height;
  }

  const { innerWidth, innerHeight } = window;

  if (!screenWidth) {
    screenWidth = innerWidth;
    screenHeight = innerHeight;
  }

  if (!screenWidth) {
    screenWidth = 375
  }
  if (!screenHeight) {
    screenWidth = 667
  }

  
  const ratio = screenWidth / screenHeight;

  // === 1. UA 初步嗅探 ===
  let uaType = 'DESKTOP'; 
  
  const isAndroid = /Android/i.test(ua);
  const isMobileUA = /Mobi|Android|iPhone/i.test(ua);
  
  // 判断 iPadOS (桌面模式)
  const isIpadNew = /Macintosh/i.test(ua) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
  // 判断真正的 MacOS 桌面端
  const isMacDesktop = /Macintosh/i.test(ua) && !isIpadNew;

  if (isIpadNew || /iPad|Tablet|PlayBook/i.test(ua) || (isAndroid && !/Mobi/i.test(ua))) {
    uaType = 'TABLET';
  } else if (isMobileUA) {
    uaType = 'MOBILE';
  }

  // === 2. 基于尺寸和比例的严谨判定 ===
  
  let finalType = DEVICE_TYPE.DESKTOP;

  // --- 档位 A：大屏设备 (宽度 >= 960) ---
  if (screenWidth >= 960) {
    if (uaType === 'DESKTOP' && screenWidth >= 1024) {
      finalType = DEVICE_TYPE.DESKTOP;
    } else {
      finalType = DEVICE_TYPE.TABLET; 
    }
  } 
  
  // --- 档位 B：中屏设备 (500 <= 宽度 < 960) ---
  // 战场：折叠屏展开 vs 竖屏平板 vs 桌面缩放窗口
  else if (screenWidth >= 500) {

    // 1. 优先排除：Mac 电脑宽度 > 800 强制为桌面
    if (isMacDesktop && screenWidth > 800) {
      finalType = DEVICE_TYPE.DESKTOP;
    } else {
      
      // 2. 定义几何特征
      // 正方形特征：折叠屏展开通常在 0.9 ~ 1.2 之间
      const isSquareLike = ratio > 0.85 && ratio < 1.3; 
      
      // 竖屏特征：比例小于 0.85 认为是典型的竖屏平板 (你的 701*955 比例为 0.73)
      const isPortraitTablet = ratio <= 0.85;

      if (uaType === 'MOBILE') {
        // Mobile UA 且宽度 > 500，几乎必然是折叠屏展开
        finalType = DEVICE_TYPE.FOLDABLE_OPEN;
      } else {
        // Tablet / Desktop UA (最复杂的判断区)
        
        if (isSquareLike) {
           // 你的折叠屏 (717*688, ratio 1.04) -> 命中这里
           finalType = DEVICE_TYPE.FOLDABLE_OPEN;
        } else if (isPortraitTablet) {
           // 你的平板 (701*955, ratio 0.73) -> 命中这里
           // 哪怕宽度很小 (701)，只要是竖长比例，就是 TABLET
           finalType = DEVICE_TYPE.TABLET;
        } else {
           // 既不方，也不竖 (通常是横宽比例 > 1.3)，且宽度 < 960
           // 这种情况可能是小尺寸横屏平板，或者非常宽的折叠屏
           // 倾向于判定为平板，除非特别小
           finalType = screenWidth < 750 ? DEVICE_TYPE.FOLDABLE_OPEN : DEVICE_TYPE.TABLET;
        }
      }
    }
  }
  
  // --- 档位 C：小屏设备 (宽度 < 500) ---
  else {
    finalType = DEVICE_TYPE.NORMAL_MOBILE;
  }

  return {
    uaType: uaType,
    type: finalType
  };
};

/**
 * 核心计算函数 (对外暴露，支持手动传参)
 * @param {Number} customWidth - (可选) 手动传入的宽度。如果不传，则读取 docEl.clientWidth
 */
export const setRem = (customWidth) => {
    // 防止服务端渲染 (SSR) 报错
    if (typeof document === 'undefined') return;

    var docEl = document.documentElement;
    var clientWidth;

    // 1. 判断是否手动传入了宽度
    if (typeof customWidth === 'number') {
        clientWidth = customWidth;
    } else {
        clientWidth = docEl.clientWidth;
    }

    if (!clientWidth) { //兜底处理
      clientWidth = 375;
    };

    if (getDeviceType().type == DEVICE_TYPE.FOLDABLE_OPEN) {
      clientWidth = (clientWidth / 2) - 20

      clientWidth = clientWidth < 375 ? 375 : clientWidth
    }

    // 2. 严格按照原代码逻辑计算
    // 375 为设计稿宽度，16 为 rootValue
    var fontSize = 16 * (clientWidth / 375);

    // 3. 设置 font-size，保留原代码中 1.2 倍的上限限制
    docEl.style.fontSize = Math.min(fontSize, 16 * 1.2) + 'px';
};

/**
 * 初始化监听函数 (对外暴露)
 * 说明：调用此方法后，会绑定 resize 事件并立即执行一次计算
 */
export const initRem = () => {
    // 防止服务端渲染 (SSR) 报错
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    // 保持原有的事件判断逻辑
    var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

    // 绑定事件，使用箭头函数包裹以调用 setRem
    window.addEventListener(resizeEvt, () => setRem(), false);
    document.addEventListener('DOMContentLoaded', () => setRem(), false);

    // 立即执行一次
    setRem();
};

initRem();
